export const headerKeys = {
  name: 'name',
  startDate: 'startDate',
  location: 'location',
  isUserRegistered: 'isUserRegistered',
};
